/**
 * 全局 401 认证失效通知桥。
 *
 * BaseService（service 层）不能直接 import authStore（store 层），
 * 否则形成循环依赖（authStore → authService → BaseService）。
 * 通过「注册回调」解耦：authStore 启动时注册 expireSession，
 * BaseService 收到 401 时只负责广播，不关心谁在监听。
 */

type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;
let lastNotifiedAt = 0;

/** 节流窗口：并发请求同时收到 401 时只触发一次登出/弹窗 */
const NOTIFY_THROTTLE_MS = 1500;

export function setUnauthorizedHandler(next: UnauthorizedHandler | null): void {
  handler = next;
}

export function notifyUnauthorized(): void {
  const now = Date.now();
  if (now - lastNotifiedAt < NOTIFY_THROTTLE_MS) return;
  lastNotifiedAt = now;
  handler?.();
}
